(function () {

  document.addEventListener('DOMContentLoaded', function () {

    function initializeProductTimers() {
      var productCards = document.querySelectorAll('[id^="product-card-"]');
      var thirtyMinutes = 3600000;
      var fiveMinutes = 300000;

      productCards.forEach(function (card) {
        var productId = card.dataset.productId;
        var blockId = card.dataset.blockId;
        var timer = document.getElementById('product-countdown-timer-' + productId + '-' + blockId);
        var progressBar = document.getElementById('product-progress-bar-' + productId + '-' + blockId);
        var mode = card.dataset.timerMode;
        var hideProduct = card.dataset.hideProduct === 'true';
        var endTime;

        if (!timer || !progressBar) {
          return;
        }

        if (mode === 'relative') {
          var duration = parseInt(card.dataset.durationHours, 10);
          var cookieKey = 'product_deal_end_' + productId + '_' + blockId;
          var savedEndTime = document.cookie.split('; ').find(row => row.startsWith(cookieKey + '='));
          if (!savedEndTime) {
            savedEndTime = localStorage.getItem(cookieKey);
          }
          if (savedEndTime) {
            endTime = parseInt(savedEndTime, 10);
          } else {
            endTime = new Date().getTime() + duration * 60 * 60 * 1000;
            var expires = new Date(endTime).toUTCString();
            document.cookie = cookieKey + '=' + endTime + '; expires=' + expires + '; path=/';
            localStorage.setItem(cookieKey, endTime);
          }
        } else if (card.dataset.endTime) {
          endTime = new Date(card.dataset.endTime).getTime();
        }

        var interval = setInterval(function () {
          var now = new Date().getTime();
          var distance = endTime - now;

          if (distance < 0) {
            timer.innerHTML = 'Deal ended';
            clearInterval(interval);
            card.querySelector('.deal-badge').style.display = 'none';
            if (hideProduct) {
              card.style.display = 'none';
            }
            return;
          }

          card.querySelector('.deal-badge').style.display = 'inline-block';

          var days = Math.floor(distance / (1000 * 60 * 60 * 24));
          var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
          var seconds = Math.floor((distance % (1000 * 60)) / 1000);

          timer.innerHTML = 'Ends in: ' + days + 'd ' + hours + 'h ' + minutes + 'm ' + seconds + 's ';

          var startTime = card.dataset.startTime === 'now' ? new Date().getTime() : new Date(card.dataset.startTime).getTime();
          var progress = ((endTime - now) / (endTime - startTime)) * 100;
          progressBar.style.width = Math.max(0, Math.min(100, progress)) + '%';
        }, 1000);
      });
    }

    // Initialize both section and product timers
    if (document.querySelector('.owl-carousel')) {
      var checkOwl = setInterval(function () {
        if (jQuery && jQuery.fn.owlCarousel && jQuery('.owl-carousel').data('owl.carousel')) {
          clearInterval(checkOwl);
          initializeProductTimers();
        }
      }, 100);
      setTimeout(function () {
        initializeProductTimers();
      }, 2000);
    } else {
      initializeProductTimers();
    }

  });

})();